module.exports = __webpack_public_path__ + "static/media/iconPix.977f0255.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/iconPix.svg
// module id = 2478
// module chunks = 0